<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <div class="mt-4"/>
    <v-container>
      <v-layout row class="mr-4">
        <div :class="ui.textTitle">
          Plan {{getPlan.basic.id}}
        </div>
        <v-spacer/>
      </v-layout>
      <v-layout row>
        <div :class="ui.textSubheading">
          {{getPlan.basic.title}}
        </div>
      </v-layout>
      <v-layout row class="mr-2">
        <v-spacer/>
        <span :class="ui.textSubheading">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
            <v-avatar>
              <v-icon>
                {{getPlan.trans.flow[getPlan.trans.flow.length - 1].icon}}
              </v-icon>
            </v-avatar>
            {{getPlan.trans.flow[getPlan.trans.flow.length - 1].title}}
          </v-chip>
        </span>
      </v-layout>
      <!-- <PlanStats/>
      <PlanList v-if="this.tag !== 'U1'" data="{tag='K6'}"/> -->
    </v-container>
    <AppNavigationBottom/>
  </div>
</template>
<script>
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
// import PlanList from "@/business/plan/components/PlanList";
// import PlanStats from "@/business/plan/components/PlanStats";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import timeFunctions from "@/data/functions/mixins/timeFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
// import Search from "@/data/search/components/Search";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop
    // PlanList,
    // PlanStats
    // Search
  },
  computed: {
    ...mapGetters(["getSearchResults", "getCurrentPage", "getPlan"]),
    tag() {
      let tag = null;
      if (this.getSearchResults !== null && this.getSearchResults.length > 0) {
        tag = this.getSearchResults[0].basic.tag;
      }
      return tag;
    },
    AppNavigationTopInfo() {
      let obj = {
        title: "Plan List",
        titleColour: "wplblue0--text",
        btns: [
          {
            title: "person",
            icon: "person",
            link: "/planlist"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      return obj;
    }
  },
  // eslint-disable-next-line
  mixins: [
    currentPage,
    apptheme,
    timeFunctions,
    dateFunctions,
    listFunctions
  ],
  data() {
    return {
      currentPagePath: "/registerlist"
    };
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
    this.$store.dispatch("changeCommsDialog", false);
  }
};
</script>
